import { Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface ReplyFilePreviewProps {
  fileCount?: number;
}

export const ReplyFilePreview = memo<ReplyFilePreviewProps>(({ fileCount = 0 }) => {
  const { t } = useTranslation();
  return (
    <div className='mex:flex mex:items-center mex:gap-2'>
      <div className='mex:flex mex:h-8 mex:w-8 mex:flex-shrink-0 mex:items-center mex:justify-center mex:rounded mex:bg-gray-200'>
        <svg className='mex:h-4 mex:w-4 mex:text-gray-400' fill='currentColor' viewBox='0 0 20 20' aria-hidden='true'>
          <path
            fillRule='evenodd'
            d='M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z'
            clipRule='evenodd'
          />
        </svg>
      </div>
      <Typography variant='body2' noWrap sx={{ color: 'text.primary' }}>
        {fileCount > 1 ? t('messages.reply.attachedFiles', { count: fileCount }) : t('messages.reply.attachedFile')}
      </Typography>
    </div>
  );
});
